const SORT_BY_FROM_ORDER = {
    1: 'loginName',
    2: 'fullName',
    3: 'description',
    4: 'status',
};

export function mapUserSearchSortParams({ orderBy, order }) {
    const sortBy =
        typeof orderBy === 'number'
            ? SORT_BY_FROM_ORDER[orderBy] || 'loginName'
            : orderBy || 'loginName';
    let direction = 'asc';
    if (order === 2 || order === 'desc' || order === 'descend') {
        direction = 'desc';
    } else if (order === 1 || order === 'asc' || order === 'ascend') {
        direction = 'asc';
    }
    return { sortBy, direction };
}

export function mapPagingToRecordInfo(paging) {
    if (!paging) {
        return { totalRecords: 0, page: 0, nrecords: 10 };
    }
    const total =
        paging.totalElements != null
            ? Number(paging.totalElements)
            : paging.totalRecords != null
            ? Number(paging.totalRecords)
            : paging.total != null
            ? Number(paging.total)
            : 0;

    const page =
        paging.page != null
            ? Number(paging.page)
            : paging.currentPage != null
            ? Number(paging.currentPage)
            : 0;

    const nrecords =
        paging.pageSize != null && Number(paging.pageSize) > 0
            ? Number(paging.pageSize)
            : paging.size != null && Number(paging.size) > 0
            ? Number(paging.size)
            : paging.nrecords != null && Number(paging.nrecords) > 0
            ? Number(paging.nrecords)
            : 10;

    return {
        totalRecords: total,
        page: page,
        nrecords: nrecords,
    };
}

/** Label status user: 0 = Inactive, -1 = Active. */
export function getUserStatusLabel(status) {
    if (status === 0 || status === '0') {
        return 'Inactive';
    }
    if (status === -1 || status === '-1') {
        return 'Active';
    }
    if (status === 'Active' || status === 'Inactive') {
        return status;
    }
    return status != null && status !== '' ? String(status) : '';
}

export function mapUserSearchRow(row) {
    return row;
}

export function mapUserDetail(body) {
    if (!body) {
        return body;
    }
    const mapped = {
        ...body,
        id: body.id != null ? body.id : body.userId,
    };

    if (Array.isArray(body.roles)) {
        mapped.roles = body.roles.map((r) => ({
            ...r,
            id: r.id != null ? r.id : r.roleId,
            name: r.name != null ? r.name : r.roleName,
        }));
    }

    if (Array.isArray(body.roles) && body.roles.length > 0 && body.role == null) {
        const primary = body.roles[0];
        mapped.role = {
            id: primary.roleId != null ? primary.roleId : primary.id,
            code: primary.code,
            name: primary.roleName != null ? primary.roleName : primary.name,
            codeDescription:
                primary.codeDescription ||
                primary.roleName ||
                primary.name ||
                primary.code,
        };
    }

    if (body.contact) {
        const c = body.contact;
        mapped.contact = {
            ...c,
            contactFirstName: c.contactFirstName || c.firstName,
            contactLastName: c.contactLastName || c.lastName,
            emailAddress: c.emailAddress || c.email,
            firstName: c.firstName || c.contactFirstName,
            lastName: c.lastName || c.contactLastName,
            email: c.email || c.emailAddress,
        };
    }

    if (body.submerchantCode != null && body.subMerchant == null) {
        mapped.subMerchant = {
            codeSubMerchant: body.submerchantCode,
            code: body.submerchantCode,
            name: body.submerchantName || body.submerchantCode,
        };
    }

    return mapped;
}

export function mapRoleRow(role) {
    if (!role) {
        return role;
    }
    return {
        ...role,
        id: role.id != null ? role.id : role.roleId,
        name: role.name != null ? role.name : role.roleName,
    };
}

export function mapRoleDetail(body) {
    if (!body) {
        return body;
    }
    return mapRoleRow(body);
}

export function mapAuditTrailMenuCatalog(body) {
    const raw = Array.isArray(body) ? body : body && body.menu ? body.menu : [];
    const menu = raw.map((item) => ({
        ...item,
        id: item.id != null ? item.id : item.menuId,
        name:
            item.displayLabel != null
                ? item.displayLabel
                : item.menuName != null
                  ? item.menuName
                  : item.name,
    }));
    return { menu };
}

export function legacyMenuPayload(body) {
    return mapAuditTrailMenuCatalog(body);
}
